/** Consecutive-day streak from completed tasks (by completedAt, local date). */

/**
 * @param {unknown} val
 * @returns {string | null}
 */
export const toLocalDateStr = (val) => {
  if (!val) return null;
  const date =
    val instanceof Date ? val : val.toDate ? val.toDate() : new Date(val);
  if (Number.isNaN(date.getTime())) return null;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/**
 * @param {Date} date
 * @param {number} offsetDays
 * @returns {string}
 */
const shiftDateStr = (date, offsetDays) => {
  const next = new Date(date);
  next.setDate(next.getDate() + offsetDays);
  return toLocalDateStr(next);
};

/**
 * @param {import('@/types').Task[]} tasks
 * @returns {Set<string>}
 */
export const buildCompletionDaySet = (tasks) => {
  const days = new Set();
  for (const task of tasks ?? []) {
    if (!task?.completed || task.archived) continue;
    const dayStr = toLocalDateStr(task.completedAt);
    if (dayStr) days.add(dayStr);
  }
  return days;
};

/**
 * Days in a row with at least one completed task.
 * Today without completions does not break the streak until the day ends.
 *
 * @param {import('@/types').Task[]} tasks
 * @param {Date} [now]
 * @returns {number}
 */
export const calculateCompletionStreak = (tasks, now = new Date()) => {
  const activeDays = buildCompletionDaySet(tasks);
  if (activeDays.size === 0) return 0;

  const todayStr = toLocalDateStr(now);
  let cursorStr = activeDays.has(todayStr) ? todayStr : shiftDateStr(now, -1);
  if (!activeDays.has(cursorStr)) return 0;

  let streak = 0;
  let offset = activeDays.has(todayStr) ? 0 : -1;

  while (activeDays.has(cursorStr)) {
    streak += 1;
    offset -= 1;
    cursorStr = shiftDateStr(now, offset);
  }

  return streak;
};
